Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-shop-the-look-box', function (envelope) {

        var $context = envelope.message.data.context,
            $shopTheLookBox = $('.x-shop-the-look-box', $context);

        if ($shopTheLookBox.length < 1) return;

        $shopTheLookBox.on('click', '.pseudo-area', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $item = $(this).closest('.x-shop-the-look-box');
            var $product = $('.x-shop-the-look-product[data-productid=' + $(this).prev('area').attr('title') + ']', $item);

            if ($(this).hasClass('visible')) {
                //close displayed product
                $(this).removeClass('visible');
                $product.removeClass('visible');

                return;
            }

            //split coords
            var coords = $(this).prev('area').attr('coords');
            coords = coords.split(',');

            //set product css properties based in coords
            $product.css({
                position: "absolute",
                top: coords[3] - ((coords[3] - coords[1]) / 2) + "px",
                left: coords[2] - ((coords[2] - coords[0]) / 2) + "px"
            });

            //hide all products
            $('.x-shop-the-look-box .pseudo-area').removeClass('visible');
            $('.x-shop-the-look-box .x-shop-the-look-product').removeClass('visible');

            //show targeted product
            $(this).addClass('visible');
            $product.addClass('visible');

            //check if product displays outside the window width
            if (isTouch() && $(window).outerWidth() > $(window).width()) {
                //revert horizontal alignment
                $(this).addClass('set-left');
                $product.addClass('set-left');
            }

            //check if product displays outside the image height
            if ($product.outerHeight() + $product.position().top > parseInt($('.image-container > img', $item).height().toFixed())) {
                //revert vertical alignment
                $(this).addClass('set-top');
                $product.addClass('set-top');
            }
        });

        $shopTheLookBox.on('click', '.x-shop-the-look-product .js-add-to-cart', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box,
                id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems;

            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;

            $box = $this.closest('.x-shop-the-look-product');

            id = $box.data('productid');
            skuId = $box.data('variantid');

            path = $box.data('path');
            qty = 1;
            extraAttributes = [];
            bundleItems = [];
            recipeItems = [];
            comboItems = [];

            var itemInfo = {
                minQuantity: parseInt($box.data('min-quantity') || 0),
                maxQuantity: parseInt($box.data('max-quantity') || 0),
                quanta: parseInt($box.data('quanta') || 0)
            };

            var enhancedInfo = {};

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
        });

        $(document).on('click', function (e) {
            if (!$('.pseudo-area', $shopTheLookBox).is(e.target) && $('.pseudo-area', $shopTheLookBox).has(e.target).length === 0) {
                //close all boxes
                if ($('.x-shop-the-look-product', $shopTheLookBox).hasClass('visible')) {
                    $('.pseudo-area', $shopTheLookBox).removeClass('visible');
                    $('.x-shop-the-look-product', $shopTheLookBox).removeClass('visible');
                }
            }
        });      

    });

});